import { createAction, props, createReducer, on } from '@ngrx/store';
import { MilesAndMoreInitState } from "../models/miles-and-more";

// Action creators using createAction
export const updateUserLoginStatus = createAction(
  '[MilesAndMore] Update User Login Status',
  props<{ payload: boolean }>()
);

export const updateUserMiles = createAction(
  '[MilesAndMore] Update User Miles',
  props<{ payload: any }>()
);

export const updateMilesBalance = createAction(
  '[MilesAndMore] Update Miles Balance',
  props<{ payload: number }>()
);

export const updateMaxMilesRange = createAction(
  '[MilesAndMore] Update Max Miles Range',
  props<{ payload: number }>()
);

export const updateSelectedMiles = createAction(
  '[MilesAndMore] Update Selected Miles',
  props<{ payload: number }>()
);

export const updateRedeemStatus = createAction(
  '[MilesAndMore] Update Redeem Status',
  props<{ payload: boolean }>()
);

export const updateCheckoutStatus = createAction(
  '[MilesAndMore] Update Checkout Status',
  props<{ payload: any }>()
);

export const updateMilesPaymentStatus = createAction(
  '[MilesAndMore] Update Miles Payment Status',
  props<{ payload: any }>()
);

export const canPayWithMiles = createAction(
  '[MilesAndMore] Can Pay With Miles',
  props<{ payload: boolean }>()
);

export const milesDiscount = createAction(
  '[MilesAndMore] Miles Discount',
  props<{ payload: number }>()
);

export const priceWhenRedeemed = createAction(
  '[MilesAndMore] Price When Redeemed',
  props<{ payload: number }>()
);

export const updateMilesErrorType = createAction(
  '[MilesAndMore] Update Miles Error Type',
  props<{ payload: any }>()
);

export const refreshMilesReducer = createAction(
  '[MilesAndMore] Refresh Miles Reducer',
  props<{ payload: any }>()
);

export const resetMiles = createAction(
  '[MilesAndMore] Reset Miles'
);

// Initial state
const initialState: MilesAndMoreInitState = {
  isUserLoggedIn: false,
  miles: null,
  selectedMiles: null,
  milesRedeemed: false,
  payByMilesResponse: null,
  milesVerified: null,
  canPayWithMiles: true,
  milesDiscount: 0,
  priceWhenRedeemed: 0,
  errorType: null,
};

// Reducer using createReducer and on
export const milesAndMoreReducer = createReducer(
  initialState,
  on(updateUserLoginStatus, (state, { payload }) => ({
    ...state,
    isUserLoggedIn: payload,
  })),
  on(updateUserMiles, (state, { payload }) => ({
    ...state,
    miles: payload,
  })),
  on(updateMilesBalance, (state, { payload }) => ({
    ...state,
    miles: { ...state.miles, milesBalance: payload },
  })),
  on(updateMaxMilesRange, (state, { payload }) => ({
    ...state,
    miles: { ...state.miles, maximumMiles: payload },
  })),
  on(updateSelectedMiles, (state, { payload }) => ({
    ...state,
    selectedMiles: payload,
  })),
  on(updateRedeemStatus, (state, { payload }) => ({
    ...state,
    milesRedeemed: payload,
  })),
  on(updateCheckoutStatus, (state, { payload }) => ({
    ...state,
    payByMilesResponse: payload,
  })),
  on(updateMilesPaymentStatus, (state, { payload }) => ({
    ...state,
    milesVerified: payload,
  })),
  on(canPayWithMiles, (state, { payload }) => ({
    ...state,
    canPayWithMiles: payload,
  })),
  on(milesDiscount, (state, { payload }) => ({
    ...state,
    milesDiscount: payload,
  })),
  on(priceWhenRedeemed, (state, { payload }) => ({
    ...state,
    priceWhenRedeemed: payload,
  })),
  on(updateMilesErrorType, (state, { payload }) => ({
    ...state,
    errorType: payload,
  })),
  on(refreshMilesReducer, (state, { payload }) => ({
    ...payload,
  })),
  on(resetMiles, () => ({
    ...initialState,
  }))
);
